import React from 'react';
import PropTypes from 'prop-types';
import { commitMutation, graphql } from 'react-relay';
import {
  Analytics,
  GlobalNotifications,
  Intent,
  Wizard
} from '../../../Modules';
import SelectPayment from './SelectPayment';
import EnterAmount from './EnterAmount';
import Confirmation from './Confirmation';

export default class InvoiceRefund extends React.Component {
  static propTypes = {
    node: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    trigger: PropTypes.node.isRequired,
    onOpen: PropTypes.func,
    onClose: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      submitting: false
    };
    this.onOpen = this.onOpen.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onPaymentSelect = this.onPaymentSelect.bind(this);
    this.onRefundTypeSelect = this.onRefundTypeSelect.bind(this);
    this.refundPayment = this.refundPayment.bind(this);
    this.refundButtonText = this.refundButtonText.bind(this);
  }

  onOpen() {
    this.setState({ refund: {}, refundType: null, selectedPayment: null });
    if (this.props.onOpen) this.props.onOpen();
  }

  onClose() {
    if (this.props.onClose) this.props.onClose();
  }

  onPaymentSelect(e, { value }) {
    this.setState({ selectedPayment: value });
  }

  onRefundTypeSelect(e, { value }) {
    this.setState({ refundType: value });
  }

  maxRefund() {
    const refundedCents = this.state.selectedPayment.refunds.edges.reduce(
      (total, paymentRefund) => total + paymentRefund.node.amount_cents,
      0
    );
    return this.state.selectedPayment.amount_cents - refundedCents;
  }

  refundPayment(model, resetForm, invalidateForm, successCb) {
    // eslint-disable-next-line no-underscore-dangle
    if (this.state.selectedPayment.__typename === 'SquarePayment') {
      this.refundSquarePayment(model, resetForm, invalidateForm, successCb);
    } else {
      this.recordManualPayment(model, resetForm, invalidateForm, successCb);
    }
  }

  recordManualPayment(model, resetForm, invalidateForm, successCb) {
    const onError = () => {
      this.setState({ submitting: false });
      GlobalNotifications.show({
        message: 'Unable to record refund',
        intent: Intent.DANGER
      });
    };
    const onCompleted = () => {
      this.setState({ submitting: false });
      if (successCb) successCb();
      Analytics.trackEvent('created-manual-refund');
    };

    const amount =
      this.state.refundType === 'full' ? this.maxRefund() : model.amount * 100;

    this.setState({
      submitting: true,
      refund: Object.assign({}, model, { amount_cents: amount })
    });

    const mutation = graphql`
      mutation Refund_createManualRefundMutation(
        $input: CreateManualRefundInput!
      ) {
        createManualRefund(input: $input) {
          invoice {
            ...InvoiceContainer_node
          }
        }
      }
    `;

    const environment = this.props.relay.environment;
    const { selectedPayment } = this.state;

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          payment_id: selectedPayment.id,
          amount_cents: amount,
          notes: model.notes,
          amount_currency: selectedPayment.amount_currency
        }
      },
      onCompleted,
      onError
    });
  }

  refundSquarePayment(model, resetForm, invalidateForm, successCb) {
    const onError = () => {
      this.setState({ submitting: false });
      GlobalNotifications.show({
        message: 'Unable to issue refund',
        intent: Intent.DANGER
      });
    };
    const onCompleted = () => {
      this.setState({ submitting: false });
      if (successCb) successCb();
      Analytics.trackEvent('created-square-refund');
    };

    const amount =
      this.state.refundType === 'full' ? this.maxRefund() : model.amount * 100;

    this.setState({
      submitting: true,
      refund: Object.assign({}, model, { amount_cents: amount })
    });

    const mutation = graphql`
      mutation Refund_refundSquareMutation($input: RefundSquareInput!) {
        refundSquare(input: $input) {
          invoice {
            ...InvoiceContainer_node
          }
        }
      }
    `;

    const environment = this.props.relay.environment;
    const { selectedPayment } = this.state;

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          payment_id: selectedPayment.id,
          amount_cents: amount,
          notes: model.notes,
          amount_currency: selectedPayment.amount_currency
        }
      },
      onCompleted,
      onError
    });
  }

  refundButtonText() {
    const { selectedPayment } = this.state;
    if (selectedPayment) {
      // eslint-disable-next-line no-underscore-dangle
      return selectedPayment.__typename === 'SquarePayment'
        ? 'Issue Refund'
        : 'Record Refund';
    }
    return 'Refund';
  }

  render() {
    const { trigger, node } = this.props;
    const { refund, refundType, selectedPayment, submitting } = this.state;
    const title = 'Issue a Refund';
    const steps = [
      {
        component: SelectPayment,
        componentProps: {
          onPaymentSelect: this.onPaymentSelect,
          payments: node.payments.edges,
          selectedPayment
        },
        actions: {
          primary: { disabled: !selectedPayment }
        },
        title
      },
      {
        component: EnterAmount,
        componentProps: {
          invoice: node,
          refundType,
          payment: selectedPayment,
          onRefundTypeSelect: this.onRefundTypeSelect
        },
        title,
        actions: {
          primary: {
            type: 'submit',
            disabled: submitting || !refundType,
            content: submitting ? 'Refunding...' : this.refundButtonText()
          }
        },
        formProps: {
          onValidSubmit: this.refundPayment
        }
      },
      {
        component: Confirmation,
        componentProps: { refund, originalPayment: selectedPayment },
        title,
        hideActions: true
      }
    ];

    return (
      <Wizard
        onOpen={this.onOpen}
        onClose={this.onClose}
        steps={steps}
        trigger={trigger}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Invoice/Refund/index.js